const tabs = {
  dashboard: "דשבורד",
  appLauncher: "כל האפליקציות",
  apps: "כל האפליקציות",
  layers: "האב",
  vcards: "vCards",
  // Legacy names — kept so old keys still resolve; the app itself is vCards now.
  editor: "עורך",
  vtaskPool: "מאגר משימות",
  storyMap: "vStory",
  notebook: "מחברת",
  memory: "זיכרון",
  chat: "צ׳אט פנימי",
  news: "חדשות",
  osMap: "מפת מערכת",
  virtualOffice: "המשרד הווירטואלי",
  roadmapBlack: "Roadmap — עמוד השדרה",
  specs: "איפיון המערכת",
  functionalMap: "מפה פונקציונלית",
  budget: "vBudget · תזרים",
  aiHub: "AI Hub",
  aiHome: "בית AI",
  cliAi: "CLI AI",
  aiAdvisors: "יועצים AI",
  advisors: "יועצים AI",
  agents: "Agents (בקרוב)",
  aiKnowledge: "AI Knowledge (בקרוב)",
  semanticBrain: "בריאות המוח",
  libraries: "ספריות",
  fieldTemplates: "תבניות שדות (בקרוב)",
  iconLibrary: "ספריית אייקונים",
  databases: "תצוגות | DB",
  integrations: "Integrations",
  myConnections: "החיבורים שלי",
  appStore: "חנות אפליקציות",
  sync: "סינכרון Origami",
  vault: "vPassword",
  vaultPasswords: "סיסמאות",
  vaultSecrets: "מידע מוצפן",
  vaultAudit: "ביקורת סטייה",
  vaultTeam: "כספת צוות",
  vcloud: "vCloud",
  vcloudFiles: "קבצים",
  vcloudImages: "ספריית תמונות",
  vcloudVideo: "וידאו",
  vcloudSound: "סאונד",
  vcloudPersonal: "מידע אישי",
  designSystem: "מערכת עיצוב",
  architecture: "ארכיטקטורה",
  plan: "תוכנית",
  roadmap: "ניהול עבודה",
  vTool: "vTool",
  settings: "הגדרות",
  automations: "אוטומציות",
  vdev: "PM — ניהול הפיתוח",
  taskInbox: "vTask | מאגר משימות",
  control: "מרכז בקרה",
  admin: "לוג פיתוח",
  adminDataBrain: "דאטה והמוח",
  health: "בריאות המערכת",
  systemCleanup: "ניקוי מערכת",
  serverHealth: "מצב השרת",
  integrationHealth: "בריאות אינטגרציות",
  honeypot: "מלכודות דבש",
  maintenance: "תחזוקת קוד",
  dbExplorer: "סייר המסד",
  dbRegistry: "אינדקס הטבלאות",
  referenceApp: "מילוני מערכת",
  notionOrder: "ארגון Notion",
  alerts: "🤖 מרכז התראות",
  identityResolver: "זיהוי בית עסק וקבלן",
  agentAccess: "🔑 גישת סוכנים",
  entities: "ישויות",
  viewsApp: "תצוגות",
  pinkas100: "פ.קבלנים 100",
  pinkasKablanim: "פנקס הקבלנים",
  investigator: "מודיעין עסקי",
  memoryCatalog: "ספריית הזיכרון",
  bookmarksApp: "סימניות",
  ideaBacklog: "רעיונות ותכנון",
  windmill: "Windmill",
  embeddedTools: "כלים מוטמעים",
  entityFields: "ספריית שדות",
  entityTypes: "סוגי ישויות",
  knowledge: "מאגר ידע",
  knowledgeSources: "מדף המקורות",
  researchLibrary: "ספריית המחקר",
  playbooks: "ספרי הפעלה",
  skills: "Claude Stack",
  skillsStore: "חנות טמפלטים (בקרוב)",
  grid: "גיליון",
  slides: "מצגת",
  boardroom: "חדר דיונים",
  feeds: "עדכוני RSS",
  bookmarks: "Bookmarks",
  readList: "Read List (בקרוב)",
  import: "ייבוא",
  matching: "התאמות",
  matchingEngine: "מנוע ההתאמות",
  talentSearch: "חיפוש בעלי כישורים",
  comms: "תקשורת",
  whatsapp: "WhatsApp",
  documents: "מסמכים",
  vclip: "vClip",
  vcanvas: "vCanvas",
  weeklyPlanner: "סדר שבועי",
  audit: "יומן ביקורת",
  templates: "תבניות",
  emailTemplates: "תבניות מייל",
  phoneTemplates: "תבניות הודעות טלפון (בקרוב)",
  prompts: "פרומפטים (בקרוב)",
  toolkit: "ארגז כלים",
  courses: "ספריית קורסים",
  cost: "בקרת עלויות",
} as const;
export default tabs;
